import script from "./ModelsDB.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelsDB.vue?vue&type=script&setup=true&lang=js"

import "./ModelsDB.vue?vue&type=style&index=0&id=032164e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-032164e8"]])

export default __exports__